import {configureStore} from '@reduxjs/toolkit';

import {UsersReducer} from '../features/users/reducers';

// Row selection state (FNP-951). Records are React Query's job; selection is Redux's.
const reducers = {
    'users': UsersReducer,
};

// serializableCheck disabled: many feature slices store Date objects, File
// handles, or other non-plain values that don't survive JSON. Matches the
// platform-wide pattern across portal, console, bot, email, and billing
// apps. Re-enable per-slice if you want stricter checks for new features.
export const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
